module.exports = __webpack_public_path__ + "media/images/dot_bg-c0075f94b1547da6b948c0f83e29e191.png";